import { getPathNetworkUtil } from '../get-path'
import { getStatusNetworkUtil } from '../get-status'

function isEqualNetworkUtil (requestA, requestB, state) {
  return (
    getPathNetworkUtil(requestA) ===
    getPathNetworkUtil(requestB) &&
    getStatusNetworkUtil(requestA, state) ===
    getStatusNetworkUtil(requestB, state)
  )
}

export { isEqualNetworkUtil }
